{
  "fr": {
    "milestone": {
      "actions": {
        "activate": "Activer",
        "activate_phase": "Activer cette phase",
        "complete_phase": "Terminer cette phase",
        "create": "Créer une phase",
        "delete": "Supprimer",
        "delete_milestones": "Supprimer la phase | Supprimer {count} phases",
        "move_down": "Déplacer la phase vers le bas",
        "move_unit_back": "Ramener l'unité ici",
        "move_up": "Déplacer la phase vers le haut",
        "new": "Phase",
        "reactivate_phase": "Réactiver cette phase"
      },
      "activate": {
        "body": "Tous les éléments de cette phase sont publiés pour cette unité et les personnes assignées reçoivent une notification.",
        "body_empty": "Ne rend rien visible pour le client.",
        "body_intermediate": "Les phases intermédiaires sont également terminées, et tous les éléments qui y sont attachés sont aussi publiés.",
        "body_project": "Tous les éléments de cette phase sont publiés pour ce projet et les personnes assignées reçoivent une notification.",
        "body_reactivate": "Cette phase redevient la phase actuelle. Rien n’est retiré : tout ce qui a déjà été publié ou envoyé reste en place. Les phases suivantes redeviennent planifiées.",
        "confirm": "Activer",
        "confirm_publish": "Activer et envoyer",
        "confirm_reactivate": "Réactiver",
        "past_warning": "Revenir à une phase antérieure n'annule pas les actions déjà effectuées. Tout ce qui a été partagé avec les clients ne sera pas automatiquement révoqué.",
        "title": "Activer la phase",
        "title_activate": "Activer « {name} » ?",
        "title_reactivate": "Réactiver « {name} » ?",
        "verb_default": "Déclencher",
        "verb_share": "Partager"
      },
      "assign": {
        "body": "Les unités sélectionnées passent à « {to} ». Les éléments de « {to} » et de chaque phase sautée deviennent visibles pour le client et les personnes assignées reçoivent une notification.",
        "body_phases_only": "Les unités sélectionnées passent à « {to} ». Le client voit la nouvelle phase.",
        "excluded": "Les unités déjà à « {to} » ou au-delà ne peuvent pas être sélectionnées."
      },
      "attach": {
        "add": "Ajouter",
        "add_and_move": "Ajouter et déplacer",
        "assigned_tag": "Attribué",
        "back": "Retour",
        "counts": "{available} disponibles · {assigned} déjà attribués",
        "description_decision": "Choix que le client doit faire",
        "description_survey": "Questionnaires pour recueillir des réponses",
        "description_todo": "Tâches que le client doit accomplir",
        "elsewhere_tag": "Actuellement dans {name}",
        "empty": "Aucun élément disponible",
        "empty_state_description": "Selon votre formule, vous pouvez ajouter {kinds} à cette phase.",
        "intro": "Choisissez le type d'élément que vous souhaitez lier à cette phase.",
        "move_notice_body": "Ce qui a déjà été envoyé le reste. L'ancienne phase perd cet élément.",
        "move_notice_item": "{element}, actuellement dans {phase}",
        "move_notice_title": "Cet élément est déplacé vers « {name} » | Ces éléments sont déplacés vers « {name} »",
        "next": "Suivant",
        "search": "Rechercher",
        "select_intro": "Sélectionnez le {kind} que vous souhaitez ajouter.",
        "subtitle": "À la phase : {name}",
        "success": "Éléments ajoutés",
        "title": "Ajouter des éléments"
      },
      "complete_phase": {
        "body": "Cette unité termine cette phase et se retrouve sans phase active. | {count} unités terminent cette phase et se retrouvent sans phase active.",
        "body_sup": "Ce projet termine cette phase et se retrouve sans phase active.",
        "confirm": "Terminer la phase",
        "keep": "Garder la phase active",
        "title": "Terminer “{name}” ?"
      },
      "delete_phase": {
        "body": "Les unités qui se trouvent sur cette phase n'auront plus de phase active. Elles ne passent pas à l'étape précédente ou suivante. Les éléments de cette phase sont détachés, pas supprimés. Les éléments déjà publiés pour une unité restent publiés : tu les supprimes sur l'unité elle-même.",
        "body_last": "Les unités qui se trouvent sur cette phase n'auront plus de phase active. Comme c'est la dernière phase, elles comptent ensuite comme terminées. Les éléments de cette phase sont détachés, pas supprimés. Les éléments déjà publiés pour une unité restent publiés : tu les supprimes sur l'unité elle-même.",
        "body_sup": "Ce projet n'aura plus de phase active. Il ne passe pas à l'étape précédente ou suivante. Les éléments de cette phase sont détachés, pas supprimés. Les éléments déjà publiés restent publiés : tu les supprimes sur le projet lui-même.",
        "confirm": "Supprimer la phase",
        "keep": "Conserver la phase",
        "title": "Supprimer « {name} » ?"
      },
      "detach": {
        "body": "Cela retire l'élément de cette phase. L'élément lui-même continue d'exister et les unités qui l'ont déjà vu le conservent. Les nouvelles unités ne le reçoivent plus à cette phase.",
        "confirm": "Détacher",
        "keep": "Conserver",
        "title": "Détacher « {name} » ?"
      },
      "filters": {
        "clear": "Effacer tous les filtres",
        "done": "Terminé",
        "group_milestones": "Phases",
        "group_status": "Statut",
        "group_title": "Contenu de la phase",
        "no_phase": "Aucune phase",
        "no_units_here": "Aucune unité ici",
        "nothing_assigned": "Rien d'attribué",
        "phase_last": "Dans la dernière phase",
        "since_month_over": "Plus d'un mois",
        "since_quarter_over": "Plus de 3 mois",
        "since_two_weeks_over": "Plus de 2 semaines",
        "title": "Filtres",
        "units_here": "A des unités ici"
      },
      "labels": {
        "add_element": "Ajouter un élément",
        "assign_units": "Assigner les unités",
        "assigned_count": "0 attribué | 1 attribué | {count} attribués",
        "assigned_elements": "Éléments attribués",
        "assigned_empty_description": "Attachez des {kinds} à cette phase",
        "assigned_empty_title": "Aucun élément pour l'instant",
        "bulk_assign_title": "Sélectionnez les unités auxquelles vous souhaitez attribuer la phase '{milestone_name}'",
        "complete_units": "Terminer {count} unité | Terminer {count} unités",
        "completed_subtitle": "Ces unités ont parcouru le workflow",
        "completed_title": "Terminé",
        "detach": "Détacher",
        "detach_element": "Détacher {name}",
        "drag_to_reorder": "Glissez pour réorganiser",
        "edit_milestone": "Editer la phase",
        "element_count": "{count} élément | {count} éléments",
        "elements_assign_link": "Attribuer des éléments dans Jalons",
        "elements_empty": "Aucun élément n'est encore attribué à cette phase.",
        "elements_visible": "Visible pour le client : {elements}",
        "empty_state_subtitle": "Les phases rendent le processus de construction plus transparent pour les acheteurs de maison",
        "empty_state_title": "Créer une nouvelle phase",
        "kind_decision": "Décision | Décisions",
        "kind_decision_count": "{count} choix | {count} choix",
        "kind_survey": "Enquête | Enquêtes",
        "kind_survey_count": "{count} enquête | {count} enquêtes",
        "kind_todo": "Tâche | Tâches",
        "kind_todo_count": "{count} tâche | {count} tâches",
        "locked_not_sent": "{count} élément est verrouillé par votre offre et ne sera pas envoyé. | {count} éléments sont verrouillés par votre offre et ne seront pas envoyés.",
        "locked_tooltip": "Non inclus dans votre offre actuelle. Ceci ne sera pas envoyé aux clients.",
        "milestone": "Phase",
        "milestone_current": "Phase actuelle",
        "milestone_name": "Nom de la phase",
        "move_units_to": "Déplacer {count} unité vers {name} | Déplacer {count} unités vers {name}",
        "new_milestone": "Nouvelle phase",
        "no_phase": "Aucune phase",
        "no_results": "Aucune phase trouvée",
        "please_select": "Veuillez sélectionner une nouvelle phase",
        "position": "Position",
        "progress": "Progression",
        "publishes_empty": "Rien d'assigné pour l'instant",
        "publishes_summary": "Rend {elements} visibles pour le client",
        "reorder_filtered": "Efface la recherche ou le filtre pour réorganiser les phases",
        "search_empty_state": "Aucune phase n'a encore été créée. Cliquez ici pour commencer",
        "search_phase": "Rechercher une phase",
        "search_unit": "Rechercher une unité",
        "search_units": "Rechercher des unités",
        "since": "Depuis",
        "started_on": "Commencée le {date}",
        "status_active": "En cours",
        "status_completed": "Terminée",
        "status_planned": "Planifiée",
        "unit_active_since": "En cours depuis le {date}",
        "unit_completed_on": "Terminé le {date}",
        "unit_timeline_empty": "Aucune phase n'a encore été créée pour ce projet.",
        "units": "Unités",
        "units_completed": "Aucune unité terminée | 1 unité terminée | {count} unités terminées",
        "units_empty": "Aucune unité n'a encore atteint cette phase.",
        "units_here": "Aucune unité ici | 1 unité ici | {count} unités ici",
        "units_no_results": "Aucune unité trouvée",
        "units_without_milestone": "1 unité sans phase | {count} unités sans phase",
        "unstarted_subtitle": "Ces unités n'ont pas de phase active",
        "unstarted_title": "Pas dans une phase",
        "warning_delete": "Si vous supprimez une phase qui a été attribuée à une unité, le client perdra de vue à quelle phase se trouve son unité. Assurez-vous d'attribuer une nouvelle phase à ces unités!"
      },
      "move": {
        "body": "Cette unité passe de « {from} » à « {to} ». Les éléments de « {to} » deviennent visibles pour le client et les personnes assignées reçoivent une notification. | Ces unités passent de « {from} » à « {to} ». Les éléments de « {to} » deviennent visibles pour le client et les personnes assignées reçoivent une notification.",
        "body_phases_only": "Cette unité passe de « {from} » à « {to} ». Le client voit la nouvelle phase. | Ces unités passent de « {from} » à « {to} ». Le client voit la nouvelle phase.",
        "confirm": "Déplacer et notifier",
        "confirm_phases_only": "Déplacer",
        "elements": "Rend {elements} visible pour le client",
        "elements_empty": "Ne rend rien visible pour le client",
        "title": "Déplacer {count} unité vers « {name} » ? | Déplacer {count} unités vers « {name} » ?"
      },
      "overview": {
        "no_phase": "Aucune phase",
        "not_started": "Pas démarré",
        "since_date": "Depuis le {date}",
        "step_of": "Étape {step} sur {total}"
      },
      "publication_failed": {
        "body": "L'envoi des éléments de cette phase a échoué pour 1 unité. | L'envoi des éléments de cette phase a échoué pour {count} unités.",
        "retried": "Les éléments sont renvoyés",
        "retry": "Renvoyer"
      },
      "reorder": {
        "body_earlier": "Avancer cette phase ne retire rien de ce qui a déjà été publié. Les unités gardent ce qu'elles ont ; seul l'ordre change.",
        "body_earlier_sup": "Avancer cette phase ne retire rien de ce qui a déjà été publié. Le projet garde ce qu'il a ; seul l'ordre change.",
        "body_later": "Reculer cette phase ne retire rien de ce qui a déjà été publié. Les unités gardent ce qu'elles ont ; seul l'ordre change.",
        "body_later_sup": "Reculer cette phase ne retire rien de ce qui a déjà été publié. Le projet garde ce qu'il a ; seul l'ordre change.",
        "body_passed": "Les unités sur une phase ultérieure passent maintenant cette phase. Tout ce qui y est lié leur est publié immédiatement.",
        "body_passed_sup": "Ce projet passe maintenant cette phase. Tout ce qui y est lié est publié immédiatement.",
        "body_passes": "Les unités sur cette phase passent maintenant les phases intermédiaires. Tout ce qui est lié à ces phases leur est publié immédiatement.",
        "body_passes_sup": "Ce projet passe maintenant les phases intermédiaires. Tout ce qui est lié à ces phases est publié immédiatement.",
        "confirm": "Déplacer la phase",
        "count": "{count} unité passe {phases} d'un coup | {count} unités passent {phases} d'un coup",
        "count_sup": "Ce projet passe {phases} d'un coup",
        "crossed": "{name} ({elements})",
        "nothing": "rien",
        "phases": "{count} phase | {count} phases",
        "title": "Placer « {name} » après « {previous} » ?",
        "title_first": "Placer « {name} » en premier ?"
      },
      "toasts": {
        "bulk_assigned": "La phase est attribuée avec succès aux unités sélectionnées",
        "create_success": "Phase créée avec succès",
        "deleted": "Phase supprimée",
        "phase_without_units": "Plus aucune unité n'est sur cette phase",
        "sup_assigned": "La phase est activée avec succès",
        "sup_completed": "Phase terminée",
        "units_completed": "{count} unité terminée | {count} unités terminées",
        "units_moved": "{count} unité déplacée | {count} unités déplacées",
        "update_success": "Les phases ont été mises à jour avec succès"
      },
      "validation": {
        "needName": "Nom requis",
        "needNamePrimary": "Le nom dans la langue principale ({language}) est requis"
      }
    }
  }
}
